module.exports = __webpack_public_path__ + "img/PMA.bf75ecbe.svg";